<template>
    <div>
        <span @dblclick="show" v-show="!show_form" style="cursor:pointer">
            {{ purchase_price }}
        </span>

        <div v-show="show_form">
            <div class="form-group">
                <input type="number"
                       min="0"
                       step="0.0001"
                       class="form-control input-sm"
                       v-model="edited_purchase_price">
            </div>
            <button @click="updateHistoryItem"
                    class="btn btn-primary"
                    v-text="trans('update_button', null)"
            ></button>
        </div>
    </div>
</template>

<script>
    let Functions = require("../../Functions");

    export default {
        props: ['purchase_price', 'state_item_id', 'current_route', 'translations'],
        data: function () {
            return {
                'show_form': false,
                'edited_purchase_price': this.purchase_price
            };
        },
        mounted: function() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        methods: {
            trans(name, path = 'stock') {
                return Functions.trans(this.translations, name, path);
            },
            show: function () {
                this.show_form = true;
            },
            updateHistoryItem: function () {
                if (this.checkPrice()) {
                    this.updatePrice(); return;
                }

                this.invalidPriceAlert();
            },
            checkPrice: function () {
                return this.edited_purchase_price > 0;
            },
            invalidPriceAlert: function () {
                alert(this.trans('error.purchase_price'));
            },
            updatePrice: function () {
                this.$http.post(this.current_route + '/update', {
                    id: this.state_item_id,
                        purchase_price: this.edited_purchase_price
                }).then(() => {
                    this.show_form = false;
                    this.$root.$emit('update-table');
                }).catch(() => {
                    this.invalidPriceAlert();
                });
            },
        },
    }
</script>
